export enum CreditGradualReleaseTypes {
  working_days = 'P',
  calendar_days = 'K',
}

export enum AccessTokenStateEnum {
  missingToken = 'Token is missing',
  missingExpiresIn = 'Token missing expire date',
  expiredToken = 'Token is expired',
  validToken = 'Token is valid',
}
